import { Alert, AlertIcon, AlertProps } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

export interface FieldErrorProps extends AlertProps {
  name: string | undefined;
}

export const FieldError = (props: FieldErrorProps) => {
  const { name = '' } = props;
  const form = useFormContext();
  const { formState } = form ?? {};

  const error = useMemo(() => {
    const { errors, dirtyFields } = formState ?? {};
    return (dirtyFields[name] && (errors[name]?.message as string)) || '';
  }, [formState, name]);

  if (error) {
    return (
      <Alert status="error" my={2}>
        <AlertIcon />
        {error}
      </Alert>
    );
  }

  return <></>;
};
